import React from 'react';
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { AccordionContainer, Loader, RadioDropdown } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFaqData, resetFaqData } from './store/actions';
import { Helmet } from 'react-helmet';
import FontResizeWidget from '../../components/FontResizeWidget';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { ACCESSIBILITY_FEATURE_ENABLED } from '../../config';
import { parseHelmetTags } from '../../utils/utility';
import searchIconGrey from '../../assets/images/svg/searchicon-grey.svg';
import searchIconGreen from '../../assets/images/svg/searchicon-green.svg';
import LandlordDiagram from '../../assets/images/svg/Landlord-diagram.svg';
import HADiagram from '../../assets/images/svg/HAdiagram.svg';
import CouncilDiagram from '../../assets/images/svg/Councildiagram.svg';
import LettingAgentDiagram from '../../assets/images/svg/Lettingagent-diagram.svg';
const FAQ = () => {
  const location = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const faqResult = useSelector((state) => state.faqList);

  const [faqQuestions, setFaqQuestions] = useState([]);
  const [data, setData] = useState();
  const [topic, setTopics] = useState([]);
  const [activeTab, setActiveTab] = useState();
  const [questioneer, setQuestioneer] = useState();
  const [titleTag, setTitleTag] = useState();
  const [metaTags, setMetaTags] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [subTopicSummary, setSubTopicSummary] = useState("");

  const complaintProceduresData = {
    faqTopics: "Complaints overview",
    imageTitle: "These diagrams show how many different options exist when you have a rental issue. To help you figure out your next steps for a specific issue, <a href='/get-advice/questions' style='color: #000; font-weight: 700; text-decoration: underline;font-family:'Helvetica';'>answer a few short questions</a> or go to \"Get help\" on the menu and we will create an action plan for you to follow more easily.",
    faqs: [
      {
        faqQuestion: "Complaints procedure when renting <span style='color: #001B9C;'>directly with a landlord</span>",
        faqResponse: `<img src="${LandlordDiagram}" alt="Complaints procedure when renting directly with a landlord" style="width: 100%; height: auto;" />`
      },
      {
        faqQuestion: "Complaints procedure when renting <span style='color: #001B9C;'>with a housing association</span>",
        faqResponse: `<img src="${HADiagram}" alt="Complaints procedure when renting with a housing association" style="width: 100%; height: auto;" />`
      },
      {
        faqQuestion: "Complaints procedure when renting <span style='color: #001B9C;'>with a council</span>",
        faqResponse: `<img src="${CouncilDiagram}" alt="Complaints procedure when renting with a council" style="width: 100%; height: auto;" />`
      },
      {
        faqQuestion: "Complaints procedure when renting <span style='color: #001B9C;'>with a letting agent</span>",
        faqResponse: `<img src="${LettingAgentDiagram}" alt="Complaints procedure when renting with a letting agent" style="width: 100%; height: auto;" />`
      }
    ]
  };

  useEffect(() => {
    dispatch(fetchFaqData());
  }, [])


  useEffect(() => {
    if (faqResult.isSuccess && faqResult.data !== null) {
      const data = faqResult.data.success.data;
      console.log("faq data", data.faqs)
      setData(data);
      setFaqQuestions(data.faqs);
      setSubTopicSummary(data.faqTopicsShortSummary)

      setTopics((prevState) => {
        data.faqTopics && Object.entries(data.faqTopics).forEach(([key, value]) => {
        console.log("prevState", value,data.faqs[key])
          if (!prevState.some(item => item.slug === key) && data.faqs[key] && data.faqs[key].length > 0) {
            prevState.push({ title: value, slug: key, isDisable: false });
          }
        });
        // Add hardcoded "Complaints overview" topic
        if (!prevState.some(item => item.slug === 'complaints-overview')) {
          prevState.push({ title: 'Complaints overview', slug: 'complaints-overview', isDisable: false });
        }
        return [...prevState];
      });


      if (location.title === undefined) {
        const defaultSlug = Object.keys(data.faqTopics)[0];
        processDefaults(defaultSlug, data);  // default slug
      } else {
        if (location.title === 'complaints-overview' && window.innerWidth < 768) {
          const defaultSlug = Object.keys(data.faqTopics)[0];
          processDefaults(defaultSlug, data);
        } else if (location.title === 'complaints-overview') {
          setActiveTab('complaints-overview');
          setQuestioneer(complaintProceduresData.faqs);
          setTitleTag('');
          setMetaTags('');
          navigate(`/faq/complaints-overview`);
        } else {
          let index = Object.entries(data.faqTopics).find((item) => {
            return item[0].toLowerCase() === location.title.replaceAll("-", " ")
          })
          if (index) {
            processDefaults(index[0], data);
          }
        }
      }

      dispatch(resetFaqData())
    } else if (faqResult.error) {
      dispatch(resetFaqData())
    }
  }, [faqResult]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768 && activeTab === 'complaints-overview' && data) {
        const defaultSlug = Object.keys(data.faqTopics)[0];
        if (defaultSlug) {
          processDefaults(defaultSlug, data);
        }
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [activeTab, data]);

  useEffect(() => {
    if (searchTerm.trim().length > 0) {
      const processedSearchKey = searchTerm.trim().toLowerCase();

      const tempTopics = []


      let firstActiveTopic = ""
      topic.map(item => {
        // Check hardcoded topic or API data
        let faqsToSearch = item.slug === 'complaints-overview' 
          ? complaintProceduresData.faqs 
          : data.faqs[item.slug];
        
        const hasMatch = faqsToSearch?.some(qa => {
          return qa.faqQuestion.toLowerCase().includes(processedSearchKey) ||
            qa.faqResponse.toLowerCase().includes(processedSearchKey)
        });

        if (hasMatch && firstActiveTopic === "") {
          firstActiveTopic = item.slug;
        }

        tempTopics.push({ ...item, isDisable: !hasMatch });
      });

      setTopics(tempTopics);
      setActiveTab(firstActiveTopic);

      searchInQA(firstActiveTopic, processedSearchKey)

    }
  }, [searchTerm]);


  const searchInQA = (firstActiveTopic, key) => {
    const tempQuestions = []
    const faqsToSearch = firstActiveTopic === 'complaints-overview' 
      ? complaintProceduresData.faqs 
      : data.faqs[firstActiveTopic];
    
    faqsToSearch?.map(item => {
      let hasMatch = item.faqQuestion.toLowerCase().includes(key) ||
        item.faqResponse.toLowerCase().includes(key);

      if (hasMatch) {
        tempQuestions.push({ ...item, isDisable: !hasMatch });
      }
    })
    setQuestioneer(tempQuestions);

  }


  const processDefaults = (req, data, skipSearch = false) => {
    const slug = req.toLowerCase().replace(/ /g, '-')
    console.log("req", req, slug)

    setActiveTab(req)

    if (req === 'complaints-overview') {
      setQuestioneer(complaintProceduresData.faqs);
      setTitleTag('');
      setMetaTags('');
      navigate(`/faq/${slug}`);
      return;
    }

    if (!skipSearch && searchTerm.trim().length > 0) {
      searchInQA(req, searchTerm.trim().toLowerCase())
    } else {
      setQuestioneer(data.faqs[req])
    }

    let { titleTag, metaTags } = parseHelmetTags(data.faqMetaData[req]);
    setTitleTag(titleTag);
    setMetaTags(metaTags);

    navigate(`/faq/${slug}`);
  }

  const clearSearch = () => {
    setSearchTerm("");

    setFaqQuestions(data.faqs);
    setSubTopicSummary(data.faqTopicsShortSummary)

    setTopics((prevState) => {
      prevState = [];
      data.faqTopics && Object.entries(data.faqTopics).forEach(([key, value]) => {
        if (data.faqs[key] && data.faqs[key].length > 0) {
          prevState.push({ title: value, slug: key, isDisable: false });
        }
      });
      if (!prevState.some(item => item.slug === 'complaints-overview')) {
        prevState.push({ title: 'Complaints overview', slug: 'complaints-overview', isDisable: false });
      }
      return [...prevState];
    });

    const defaultSlug = Object.keys(data.faqTopics)[0];
    processDefaults(defaultSlug, data, true);  
  };

  const onTabChange = (title, slug) => {
    processDefaults(slug, data);
  };


  return (<div className='faq'>
    {ACCESSIBILITY_FEATURE_ENABLED ?
      <FontResizeWidget minSize={14} maxSize={32} step={2} defaultSize={16} /> : null}

    {titleTag !== '' ? <Helmet>{titleTag} {metaTags} </Helmet> :
      <Helmet>
        <title> {`${data?.faqTopics[activeTab] + " | "}FAQ | My Housing Gateway`}</title>
      </Helmet>}

    {faqResult.isFetching ? (
      <Loader message={"Loading....."} />
    ) : faqResult.isSuccess && !Array.isArray(faqQuestions) ? (
      <div className='container'>
        <h2 className='mt-4 mt-md-5 text-title-28 darkGrey'>Frequently asked questions</h2>

        <div className="row mb-4">
          <div className="col-12 col-md-7">
            {activeTab ? (
              <p className="text-body-16 darkGrey mb-0">
                {/* {subTopicSummary[activeTab]?.summary} */}
                  {subTopicSummary?.[activeTab]?.summary ?? ''}
              </p>
            ) : null}
          </div>
          <div className="col-12 col-md-5">
            <div
              className="search-input-wrapper"
              style={{ position: "relative", marginLeft: "auto" }}
            >
              <img
                src={inputFocused ? searchIconGreen : searchIconGrey}
                alt="Search"
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  left: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 22,
                  height: 22,
                }}
              />
              <input
                type="text"
                className="form-control shadow-none faq-search-input mt-3 mt-md-0 "
                placeholder="Search by keyword"
                value={searchTerm}
                onChange={(e) => {

                  if (e.target.value.length > 0) {
                    setSearchTerm(e.target.value.toLowerCase())
                  } else if (e.target.value.length === 0) {
                    clearSearch();
                  }

                }}
                onFocus={() => setInputFocused(true)}
                onBlur={() => setInputFocused(false)}
                style={{
                  paddingLeft: 40,
                  height: 44,
                  paddingRight: 70,
                  borderRadius: 9999,
                  background: "#fff",
                }}
              />
              {searchTerm && (
                <button
                  type="button"
                  className="search-clear-btn"
                  onClick={() => clearSearch()}
                  style={{
                    position: "absolute",
                    right: 25,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    color: "#003078",
                    fontWeight: 700,
                    fontSize: 16,
                    padding: 0,
                    zIndex: 2,
                    cursor: "pointer",
                  }}
                >
                  Clear
                </button>
              )}
            </div>
          </div>
        </div>


        <div className='d-flex justify-content-between flex-column flex-md-row faq-content'>
          <div className="col-md-3 d-none d-md-block">
            <h3 className='text-sub-title-20 faq-topic-title'>Topics</h3>
            {
              topic && topic.length > 0 ? (
                <ul className='d-flex flex-column mt-4'>
                  {
                    topic.map((item, index) => {
                      console.log("item", item)
                      return (
                        <li className={`${activeTab === item.slug ? 'flex-grow-1 alig-items-stretch mb-3 active' : 'flex-grow-1 alig-items-stretch mb-3'} ${item.slug === 'complaints-overview' ? 'd-none d-md-block' : ''}`} key={index}><Button className='d-block bg-white text-sub-title black fw-normal' onClick={() => onTabChange(item.title, item.slug)} disabled={item.isDisable}>{item.title}</Button></li>
                      )
                    })
                  }
                </ul>
              ) : null
            }
          </div>
          {
            activeTab &&
            <RadioDropdown
              title={topic.find(term => term.slug === activeTab)?.title}
              options={topic.filter(item => item.slug !== 'complaints-overview')}
              onChange={onTabChange}
              labelText="Topic"
            />
          }


          <div className='accordion-list-container col-md-8 bg-white p-md-4 mb-5'>
            {activeTab === 'complaints-overview' && complaintProceduresData.imageTitle && (
              <p className="text-body-16 darkGrey mb-4 d-none d-md-block" dangerouslySetInnerHTML={{__html: complaintProceduresData.imageTitle}} />
            )}
            {questioneer && questioneer.length > 0 ? (
              <div className={activeTab === 'complaints-overview' ? 'd-none d-md-block' : ''}>
                <AccordionContainer list={questioneer} accordionClicked={() => { }} />
              </div>
            ) : searchTerm.length > 0 ? <p className="text-20 mt-2">No results found for "{searchTerm}"</p> :  <div className='container'>
              <p className='text-12 mt-4'>No data found</p>
            </div>
            }
          </div>
        </div>
      </div>
    ) : faqResult.isSuccess && Array.isArray(faqQuestions) ?
      <div className='container'>
        <p className='text-24 mt-4'>No data found</p>
      </div>
      : null}


  </div>
  )
}

export default FAQ
